<template>
	<div style="display: inline-block;">
		<Button class="jxyd-borderbtn jxyd-searchbtn" title="创建订单" @click="openSalesPlanListModal" style="margin-right:10px;"
			:disabled="isDisabled">
			<Icon type="md-add-circle" size='18'/> 调订单
		</Button>
		<Modal v-model="selectSalesPlanModal" draggable sticky scrollable :fullscreen="fullscreen" :width="1000"
			:styles="{top: '20px','backgroud-color':'white'}">
			<p slot="header" class="modal-header">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				<span style="float: left;font-weight: bold;">选取订单</span>
			</p>
			<div class="modal-content">
				<div style="padding: 16px;">
					<div id="box-search">
						<div class="box-search-left">
							<Input type="text" class="search_input" v-model="searchItems.searchVal" placeholder="输入订单名/操作员/客户/备注" @keyup.enter.native="initSalesPlanList(1)" />
							<DatePicker type="daterange"
							            show-week-numbers
							            placement="bottom-end"
							            placeholder="选择业务日期/制单日期"
							            v-model="searchItems.businessDate"
							             class="search_input">
							</DatePicker>
							<button class="jxyd-button jxyd-primary jxyd-searchbtn" @click="initSalesPlanList(1)">查询</button>
						</div>
						<Button class="jxyd-borderbtn box-search-right" @click="addSalesPlanList" v-show="permission.isAdd">
							新建订单
						</Button>
					</div>
					<Table stripe :height='500' :columns="planListColumn" :data="planListData" @on-select="listSelected"
						@on-select-cancel='listSelectedCanel' @on-select-all='listSelectAll' @on-select-all-cancel='listSelectAllCanel'>
					</Table>
					<div id="page-box">
						<Page show-sizer :total="planListCount" :page-size="searchItems.pageSize" @on-change="pageChange"
							show-total show-elevator :page-size-opts ='pageSizeOpts' :current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
						</Page>
					</div>
				</div>
				<!-- 自定义抽屉组件 -->
				<transition name="slide-right">
					<div v-if="shoppingCart" class="custom-drawer">
						<div class="drawer-title">
							<div class="drawer-title-left">
								已选
								<span class="drawer-title-left-number">
									{{tableRows.length}}
								</span>
							</div>
							<div class="drawer-title-right" @click="cleanSelected">清空已选</div>
						</div>
						<Table :height='680' disabled-hover :columns="selectedColumn" :data="tableRows">
						</Table>
					</div>
				</transition>
			</div>
			<div slot="footer">
				<div class="selected-goods" @click="shoppingCart=!shoppingCart">
					<Icon type="md-cart" size='20'/>
					<Badge :count="tableRows.length">
						<span>已选订单</span>
					</Badge>
				</div>
				<div class="footer-tool">
					<button class="jxyd-button" @click="selectSalesPlanModal = false">取消</button>
					<button class="jxyd-button jxyd-primary" type="primary" @click="Submit">确定</button>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
    import formatDate from '@/utils/formatDate'

	export default {
		name: 'SelectSalesPlanModal',
		props: ['selectSalesPlanIds', 'isDisabled'],
		data() {
			return {
				selectSalesPlanModal: false,
				fullscreen: false,
				planListColumn: [
					{
						type: '单选',
						width: 60,
						align: 'center',
						fixed: 'left',
						render:(h,params)=> {
                            let flag = false;
							this.tableRows.forEach((item,index)=>{
								if (item.id === params.row.id) {
								    flag = true;
								}
							})
                            
                            return h('div', [
                                h('Radio', {
                                    props: {
                                        value: flag
                                    },
                                    on: {
                                        'on-change': () => {
											this.tableRows = [params.row];
                                        }
                                    }
                                })
                            ])
                        }
					},
					{
						title: '订单编号',
						key: 'code',
						width: 200,
						render:(h, params)=> {
							return h('a',{
								class:'jxyd-a',
								on: {
								    click: (e) => {
										this.selectSalesPlanModal = false;
								        this.$router.push({
								        	path: 'salesplanlistdetail',
											query: {
												planListId: params.row.id
											}
								        });
								    }
								}
							}, " " + params.row.code)
						}
					},
					{
						title: '业务日期',
						key: 'businessDate',
						width: 150,
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '客户',
						key: 'customerName',
						width: 200,
					},
					{
						title: '业务员',
						key: 'userName',
						width: 120,
					},
					{
						title: '制单日期',
						key: 'createDate',
						width: 120,
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.createDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '订单状态',
						key: 'checkState',
						width: 200,
						align: 'center',
						render: (h, params) => {
							switch (params.row.checkState) {
								case 1:
									return h('Tag', {
										style: {
										},
										attrs: {
											color:'magenta'
										}
									}, '已创建');
								case 2:
									return h('Tag', {
										style: {
										},
										attrs: {
											color:'red'
										}
									}, '已审核');
								case 3:
									return h('Tag', {
										style: {
										},
										attrs: {
											color:'success'
										}
									}, '已完结');
							}
						}
					},
					{
						title: '金额',
						key: 'amount',
						width: 150
					},
					{
						title: '定金',
						key: 'deposit',
						width: 150
					},
					{
						title: '支付方式',
						key: 'payWay',
						width: 150
					},
					{
						title: '备注',
						key: 'note',
						width: 400
					}
				],
				planListData: [],
				planListCount: 0,
				tableRows: [],
				searchItems: {
					searchVal: '',
					businessDate:[],
					pageSize: 10,
					pageIndex: 1
				},
				advancedSelect: false,
				shoppingCart: false,
				selectedColumn: [
					{
						title: '订单编号',
						key: 'code',
						width: 200,
						render:(h, params)=> {
							return h('a',{
								class:'jxyd-a',
								on: {
								    click: (e) => {
										this.selectSalesPlanModal = false;
								        this.$router.push({
								        	path: 'salesplanlistdetail',
											query: {
												planListId: params.row.id
											}
								        });
								    }
								}
							}, " " + params.row.code)
						}
					},
					{
					    title: '业务日期',
					    key: 'businessDate',
					    width: 150,
					    render: (h, params) => {
					        return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
					    }
					},
					{
					    title: '客户',
					    key: 'customerName',
					    width: 200,
					},
                    {
                        title: '业务员',
                        key: 'userName',
                        width: 120,
                    },
					{
					    title: '操作',
					    key: 'action',
					    align: 'center',
					    fixed: 'right',
						width:80,
					    render: (h, params) => {
					        return h('a', {
								class:'jxyd-a',
					            props: {
					            },
					            style: {
					            },
					            on: {
					                click: (val) => {
					                    this.tableRows.splice(params.index,1);
										this.initSalesPlanList(1);
					                }
					            }
					        },"删除");
					    }
					}
				],
				pageSizeOpts:[10,20,30,40,50,60,70,80,90,100],
				permission:{
					isAdd:false
				}
			}
		},

		methods: {
			Submit() {
				this.$emit('getResult', this.tableRows);
				this.selectSalesPlanModal = false;
			},
			getPlanList(planListId) {
				let self = this;
				request.get('/api/SalesPlanList/GetSalesPlanList', {
					params: {
						id: planListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.tableRows = [response.data];
				}).catch(function(error) {})
			},
			openSalesPlanListModal() {
				this.selectSalesPlanIds.forEach((item,index)=>{
					if(item > 0){
					this.getPlanList(item);
					}
				});
				setTimeout(()=>{
					this.initSalesPlanList(1);
					this.selectSalesPlanModal = true;
				},200);
			},
			initSalesPlanList(index) {
				let component = this;
				component.searchItems.pageIndex = index;
				request.post('/api/SalesPlanList/GetSalesPlanListToModal', component.searchItems).then(function (response) {
				    if (response.state == 0) {
				        component.$Notice.error({
				            title: '错误提示',
				            duration: 3,
				            desc: "获取数据失败：" + response.errorMsg
				        });
				        return;
				    }
				
				    component.planListData = response.data.salesPlanList;
				    component.planListCount = response.data.count;
					component.initSelectedRow();
				}).catch(function (error) {
				})
			},
			initSelectedRow() {
				this.tableRows.forEach((item, index) => {
					this.planListData.forEach((item2,index2)=>{
						if(item.id == item2.id){
							item2._checked = true;
						}
					});
				});
			},
			pageChange(index) {
				this.initSalesPlanList(index);
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initSalesPlanList(1);
			},
			listSelectAll(items){
				let isExist = false;
				for(let i = 0;i<items.length;i++){
					isExist = false;
					for(let n = 0; n<this.tableRows.length;n++){
						if(items[i].id === this.tableRows[n].id){
							isExist = true;
							break;
						}
					}
					if(!isExist){
						this.tableRows.push(items[i]);
					}
				}
			},
			listSelectAllCanel(items){
				for(let i = 0;i<this.planListData.length;i++){
					for(let n = 0; n<this.tableRows.length;n++){
						if(this.planListData[i].id === this.tableRows[n].id){
							this.tableRows.splice(n,1);
							break;
						}
					}
				}
			},
			listSelected(items, row) {
				this.tableRows.push(row);
			},
			listSelectedCanel(items, row) {
				this.tableRows.forEach((item,index)=>{
					if(row.id == item.id){
						this.tableRows.splice(index, 1);
					}
				});
			},
			cleanSelected(){
				this.tableRows = [];
				this.initSalesPlanList(1);
			},
			addSalesPlanList() {
				this.selectSalesPlanModal = false;
				this.$router.push({
					path: 'salesplanlistfunc'
				});
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['SalesPlanList.Add'],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'SalesPlanList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			}
		},
		watch: {
			'searchItems.businessDate': {
			    handler(val) {
			        if (val[0] == '') {
			            this.searchItems.businessDate = [];
			        }
			    }
			}
		},
		created: function() {
			this.initPermission();
		}
	}
</script>

<style scoped>
	#page-box {
		margin-top: 15px;
		text-align: center;
	}

	.selected-goods {
		float: left;
		height: 52px;
		line-height: 52px;
		text-align: center;
		width: 150px;
		color: #fff;
		background-color: rgb(255, 106, 127);
		font-size: 15px;
		cursor: pointer;
		font-weight: bold;
	}

	/deep/ .ivu-modal-footer {
		padding: 0px !important;
	}

	.footer-tool {
		padding: 10px;
	}

	/deep/ .ivu-badge-count {
		top: -3px;
	}

	.drawer {
		width: 300px;
		height: 500px;
		background-color: aqua;
	}

	/* 过渡动画样式 */
	.slide-right-enter-active,
	.slide-right-leave-active {
		transition: all 0.3s ease;
	}

	.slide-right-enter,
	.slide-right-leave-to {
		transform: translateX(100%);
	}

	/* 自定义抽屉样式 */
	.custom-drawer {
		position: absolute;
		top: 0;
		right: 0;
		width: 450px;
		/* 可调整抽屉宽度 */
		height: 100%;
		/* 充满模态框高度 */
		background-color: #fff;
		box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
		z-index: 1000;
		/* 确保在模态框内容之上 */
		/* overflow-y: auto;
		如果内容超出，可滚动 */
		padding: 10px;
	}

	/deep/ .ivu-modal-content {
		background-color: white;
	}

	/deep/ .ivu-modal-body {
		padding: 0px;
	}

	.drawer-title {
		margin-bottom: 10px;
	}

	#box-search{
		margin-bottom: 15px;
		overflow: hidden;
	}
	
	.search_input{
		width: 210px;
		margin-right: 15px;
	}
	
	.box-search-left{
		float: left;
	}
	
	.box-search-right{
		float: right;
	}
	.modal-header{
		overflow:hidden;
		color:rgb(255, 106, 127);
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
</style>